export default "__VITE_ASSET__CYU3iSaR__"